import Clients from '@/components/Clients/Clients.vue';
import ClientsDetail from '@/components/Clients/ClientsDetail.vue';

export default [
    {
        name: 'clients',
        path: '/clients',
        component: Clients,
        meta: { roles: ['role_administrator'] },
    },
    {
        name: 'clients-detail',
        path: '/clients/detail/:id?',
        component: ClientsDetail,
        meta: { roles: ['role_administrator'] },
    },
];
